import {faFilter} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import * as styles from './filter-icon.scss';

export function FilterIcon(): JSX.Element {
    return <FontAwesomeIcon className={styles.FilterIcon} icon={faFilter} />;
}
